import { render, staticRenderFns } from "./CountNewOrdersFuncBased.vue?vue&type=template&id=7d61d3bf&"
import script from "./CountNewOrdersFuncBased.vue?vue&type=script&lang=js&"
export * from "./CountNewOrdersFuncBased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports